import * as React from 'react'
import { JSX } from 'react/jsx-runtime'

export function Business(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.8075 24.8324C32.2557 27.0797 26.1871 28.3173 19.8294 28.3173C13.4718 28.3173 7.40314 27.0797 1.85132 24.8324M27.8197 10.3392V6.3441C27.8197 4.13765 26.031 2.34897 23.8245 2.34897H15.8343C13.6278 2.34897 11.8391 4.13765 11.8391 6.3441V10.3392M19.8294 22.3246H19.8494M5.84645 38.3051H33.8124C36.0188 38.3051 37.8075 36.5165 37.8075 34.31V14.3344C37.8075 12.1279 36.0188 10.3392 33.8124 10.3392H5.84645C3.64 10.3392 1.85132 12.1279 1.85132 14.3344V34.31C1.85132 36.5165 3.64 38.3051 5.84645 38.3051Z"
        stroke={props.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
